import * as request from '../api-request'
import getToken from '../get-token'

const makeRequest = async (method = 'POST', endpoint, data = {}, token, responseType = 'json') => {
  const configs = {}
  if (method === 'POST') {
    configs.body = JSON.stringify(data)
  }
  // eslint-disable-next-line no-undef
  const response = await fetch(`/api/${endpoint}`, {
    method: method,
    ...configs,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
  if (!response.ok) {
    const error = new Error(response.statusText)
    error.status = response.status
    throw error
  }
  return response[responseType]()
}

export const upsertUser = async (data = {}) => {
  return request.toJSON('POST', 'user', data)
}

export const proTrialAccess = async (data = {}) => {
  return request.toJSON('POST', 'user/e3ud0s', data)
}

export const getUserInvoices = async (data, token) => {
  token = token || (await getToken())
  // skip store data if there is no token provided
  if (!token) {
    throw Error('Token is required')
  }
  return request.toJSON('GET', 'user/invoices', { }, token)
}

export const hasAdminPrivilege = async (token) => {
  token = token || (await getToken())
  return request.toJSON('GET', 'admin/has_privilege', { }, token)
}

export const getOTP = (data) => {
  const queryString = new URLSearchParams(data)
  return makeRequest('GET', `get_otp?${queryString}`, {}, '')
}

export const getRemainingRequests = (token) => {
  return request.toJSON('GET', 'user/remaining_requests', { }, token)
}

export const getUserInfo = () => {
  return request.toJSON('GET', 'user/get_user_info')
}

export const getProfile = () => {
  return request.toJSON('GET', 'user/profile')
}

export const updateProfile = (data) => {
  return request.toJSON('PATCH', 'user/profile', data)
}

export const verifyCaptcha = (data) => {
  return request.toJSON('POST', 'user/verify_captcha', data)
}

export const checkout = async (data = {}) => {
  return request.toJSON('POST', 'user/payment/checkout', data)
}

export const deleteUser = async (data = {}) => {
  return request.toJSON('POST', 'user/delete', data)
}
